<template>
  <div class="enumeration">
    <vcv-select
      class="enumeration__select"
      :label="computedPlaceholder"
      :options="computedOptions"
      :selected="selectedOptions"
      :is-multiselect="configuration.allow_multiple"
      :menu-width="350"
      menu-position="right"
      is-show-badge
      is-search
      @select="selectOptions($event)"
    />

    <div v-if="configuration.allow_other" class="enumeration__other">
      <vinput
        :value="computedOtherValue"
        :placeholder="$tr('vacancy.preferences.application.addAnswers3')"
        border
        @input="changeOther"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import VcvSelect from '@/components/VcvSelect.vue';

export default {
  name: 'AnswersEnumeration',

  components: {
    VcvSelect
  },

  props: {
    data: {
      type: [Array, Object],
      default: () => []
    },

    id: {
      type: [String, Number],
      default: ''
    },

    configuration: {
      type: [Object],
      default: null
    }
  },

  computed: {
    ...mapGetters('interview/application', ['getAnswersObject']),

    computedOptions() {
      const newAnswers = [...this.data];
      return newAnswers
        .sort((a, b) => (a.sort_order > b.sort_order ? 1 : b.sort_order > a.sort_order ? -1 : 0))
        .map(x => ({ value: x.id, text: x.value, sort_order: x.sort_order }));
    },

    computedPlaceholder() {
      return this.configuration !== null
        ? this.configuration.allow_multiple
          ? this.$tr('vacancy.tests.form.questions.types.title')
          : this.$tr('common.selectOption')
        : this.$tr('common.selectOption');
    },

    selectedOptions() {
      return this.configuration.allow_multiple !== undefined && !!this.configuration.allow_multiple
        ? this.getAnswersObject(this.id).enumeration_items !== undefined
          ? this.getAnswersObject(this.id).enumeration_items
          : []
        : this.getAnswersObject(this.id).enumeration_items !== undefined
        ? [this.getAnswersObject(this.id).enumeration_items]
        : [];
    },

    computedOtherValue() {
      return this.configuration.allow_other
        ? this.getAnswersObject(this.id).other !== undefined
          ? this.getAnswersObject(this.id).other
          : ''
        : '';
    }
  },

  methods: {
    ...mapMutations('interview/application', ['SET_OTHER_ANSWER']),

    selectOptions(newOptions) {
      let obj = {};

      if (this.configuration.allow_multiple) {
        obj = Object.assign(obj, null, {
          question_id: this.id,
          enumeration_items: newOptions
        });
      } else {
        obj = Object.assign(obj, null, {
          question_id: this.id,
          enumeration_items: [newOptions]
        });
      }

      if (this.configuration.allow_other && !this.configuration.allow_multiple) {
        this.SET_OTHER_ANSWER({ questionId: this.id, newValue: '' });
      }

      this.$emit('update', obj);
    },

    changeOther(newValue) {
      if (this.configuration.allow_other && !this.configuration.allow_multiple) {
        this.$emit('update', { question_id: this.id, enumeration_items: [] });
      }

      this.SET_OTHER_ANSWER({ questionId: this.id, newValue });
    }
  }
};
</script>

<style lang="scss" scoped>
.enumeration {
  &__select {
    width: 350px;

    @media screen and (max-width: 400px) {
      width: 100%;
    }
  }

  &__other {
    width: 350px;
    margin-top: 10px;

    @media screen and (max-width: 400px) {
      width: 100%;
    }
  }
}
</style>
